import { getLoginMethodByUserId } from '@calm/web-common/dist/user-id';
import { useMemo } from 'react';
import useAccount from '../use-account';

export function useLoginMethod() {
    const { account } = useAccount();

    const loginMethod = useMemo(
        () =>
            typeof account?.userId === 'string'
                ? getLoginMethodByUserId(account?.userId)
                : undefined,
        [account?.userId]
    );

    return loginMethod;
}
